import languages from '$i18n/languages.json';

/** @type {import('./$types').PageLoad} */
export function load({ params }) {
    return {
        lang: params.lang
    };
}

export const prerender = true;

// 为所有支持的语言生成预渲染路径
export const entries = () => {
    return Object.keys(languages).map(lang => ({ lang }));
};
